

































import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import CoinIcon from '@/components/icons/WidgetCoin.vue';
import BillingPlanOverview from '@/componentsV2/molecules/BillingPlanOverview/BillingPlanOverview.vue';
import { FilledButton } from '@/components/molecules';
import eventBus from '@/utils/eventBus';
import { IOfferListItem } from '@/models/offer';

export type TLocationAction = 'delete' | 'new';

@Component({
  components: {
    Typography,
    CoinIcon,
    BillingPlanOverview,
    FilledButton
  }
})
export default class PlanOverview extends Vue {
  @Prop({ default: 'new' }) action!: TLocationAction;
  @Prop() offers!: IOfferListItem[];
  @Prop() subscription!: any;

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get description() {
    if (this.action === 'delete')
      return 'You have removed one location from your account and your minting Coins plan has been updated:';

    return 'You have added one location to your account and your minting Coins plan has been updated:';
  }

  get ctaText() {
    if (this.action === 'delete' || !this.offers.length) return 'Got it';

    return 'Continue';
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  goToPlanDetails() {
    this.onClose();
    this.$router.push('/coin-network-plan');
  }

  submit() {
    if (this.action === 'delete' || !this.offers.length) {
      this.onClose();
      return;
    }
    this.$emit('goToNextStep');
  }
}
